import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { PreloaderHandler, DOTS_FULL, MULTICOLOR_FULL, BLUE_FULL } from '../../preloader/preloader-handler';
import { OidcSecurityService } from '../../../auth/services/oidc.security.service';
import { ActivityWidgetService } from './activity-widget.service';
import { ActivitySearchModel } from '../../models/activity-related/ActivitySearchModel';
import { NotificationHandlerService } from '../../notifications/notification-handler.service';

@Component({
    selector: 'activity-widget',
    templateUrl: 'activity-widget.component.html'
})

export class ActivityWidgetComponent {

    @Input() data: ActivitySearchModel;
    @Output() updated = new EventEmitter();
    @Output() deleted = new EventEmitter();
    @Output() export = new EventEmitter();
    public preloaderHandler: PreloaderHandler;
    private isEditable = false;
    private deleteConfirm = false;

    constructor(private _widgetService: ActivityWidgetService,
        private _notificationService: NotificationHandlerService,
        public oidcSecurityService: OidcSecurityService) {
        let timeout = 850;
        let itemLoadCount = 1;
        this.preloaderHandler = new PreloaderHandler(itemLoadCount, timeout, BLUE_FULL);
    }

    ngOnInit(): void {
        if (this.data) {
            this.preloaderHandler.itemLoaded();
        }
    }

    private exportData(): void {
        this.export.emit(this.data);
    }

    private refreshData(): void {
        this.preloaderHandler.reset();
        this.getData();
    }

    private toggleDeleteConfirm(): void {
        this.deleteConfirm = !this.deleteConfirm;
    }

    private toggleEdit(): void {
        this.isEditable = !this.isEditable;
    }

    private cancelEdit(): void {
        this.isEditable = false;
    }

    private saveData(): void {
        this.toggleEdit();
        this.preloaderHandler.reset();
        this._widgetService
            .Update(this.data.Id, this.data.Activity)
            .subscribe(data => {
            },
            error => {
                this.oidcSecurityService.handleError(error),
                this._notificationService.handleError(error)
            },
            () => {
                this.refreshData(),
                this.updated.emit(true)
            });
    }

    private deleteData(): void {
        this.preloaderHandler.reset();
        this._widgetService
            .Delete(this.data.Id)
            .subscribe(data => {
            },
            error => {
                this.oidcSecurityService.handleError(error),
                this._notificationService.handleError(error)
            },
            () => {
                this.deleted.emit(this.data)
            });
    }

    private getData(): void {
        this._widgetService
            .Get(this.data.Id)
            .subscribe(data => {
                this.data = data
            },
            error => {
                this.oidcSecurityService.handleError(error),
                this._notificationService.handleError(error)
            },
            () => {
                this.preloaderHandler.itemLoaded()
            });
    }

    private getDateStr(): string {
        let date = new Date(this.data.DateEdited);
        let months = [' Jan ', ' Feb ', ' Mar ', ' Apr ', ' May ', ' Jun ',
            ' Jul ', ' Aug ', ' Sep ', ' Oct ', ' Nov ', ' Dec '];
        return (date.getDate() + months[date.getMonth()].toUpperCase() + date.getFullYear());
    }


}



// WEBPACK FOOTER //
// ./angularApp/app/shared/activity-widget-container/activity-widget/activity-widget.component.ts